import { createSelector } from 'reselect'

export const isPostPurchaseAncillaryPayment = createSelector(
  (state: App.State) => state.checkout.cart.mode,
  (cartMode) => cartMode === 'deposit-balance' || cartMode === 'instalment-balance' || cartMode === 'instalment' || cartMode === 'reserve-balance' || cartMode === 'payment-schedule-balance',
)
